/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module NetworkServiceModule
 */

import { INetworkService } from 'generated-types';
import {
    IItemArgs,
    Item,
} from '../../data-model/factories/item.factory';

/**
 * @author Akul Aggarwal
 * @description Item for network_service
 */
export class NetworkService extends Item<INetworkService> {
    constructor(args = {} as any as IItemArgs<INetworkService>) {
        super({
            objectName: 'networkservice',
            ...args,
        });
    }
}

export const NETWORK_SERVICE_TOKEN = 'NetworkService';
